import React from "react";
import "../../../css/table.css";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { toArray, orderBy } from "lodash";
import PlaceForm from "../../../forms/PlaceForm.jsx";
import Modal from "../../../components/Modal/Modal.jsx";
import { db } from "../../../services/firebase";
import { resetForm } from "../../../ducks/Forms";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import Button from "../../../elements/CustomButton/CustomButton.jsx";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import SweetSpinner from "../../../components/SweetSpinner/SweetSpinner.jsx";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { style as NotifyStyle } from "../../../variables/Variables.jsx";
import { faPencilAlt, faTrash } from "@fortawesome/fontawesome-free-solid";

class Places extends React.Component {
  constructor(props) {
    super(props);
    this.companyID = props.companyID;

    this.state = {
      fetchingPlaces: true,
      lineModal: false,
      targetLine: null,
      places: {},
      alert: null,
      _notificationSystem: null,
    };
  }

  componentDidMount() {
    this._fetchPlaces();
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  render() {
    return (
      <div>
        {this.state.alert}
        {this.placeModal()}
        <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
        <Row>
          <Col md={12}>
            <Button
              bsStyle="default"
              wd
              className="pull-right"
              style={{ marginBottom: 10 }}
              onClick={() => {
                this.props.resetForm("PlaceForm");
                this.setState({ placeModal: true, targetPlace: null });
              }}
            >
              Adicionar Local
            </Button>
          </Col>
        </Row>
        {this._renderPlacesTable(this.state.places)}
      </div>
    );
  }

  _fetchPlaces = () => {
    const { companyID } = this.props;
    this.setState({ fetchingPlaces: true });
    db.collection("companies")
      .doc(companyID)
      .collection("places")
      .onSnapshot((placeSnapshot) => {
        if (!placeSnapshot.empty) {
          const places = [];
          placeSnapshot.forEach((place) =>
            places.push({ ...place.data(), id: place.id })
          );
          this.setState({ fetchingPlaces: false, places });
        } else {
          this.setState({ fetchingPlaces: false });
        }
      });
  };

  _setPlace = (values) => {
    this.setState({ placeModal: false });
    this.waitAlert("Salvando dados", true);
    const { companyID } = this.props;
    db.collection("companies")
      .doc(companyID)
      .collection("places")
      .add({ name: values.name })
      .then(() => {
        this.hideAlert();
        this.notify("Local adicionado", "success");
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao adicionar local", "error");
      });
  };

  _updatePlace = (placeID) => (values) => {
    this.setState({ placeModal: false });
    this.waitAlert("Atualizando dados", true);
    const { companyID } = this.props;
    db.collection("companies")
      .doc(companyID)
      .collection("places")
      .doc(placeID)
      .update({ name: values.name })
      .then(() => {
        this.hideAlert();
        this.notify("Local atualizado", "success");
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao atualizar local", "error");
      });
  };

  _remove = (id) => {
    this.hideAlert();
    this.waitAlert("Validando dados, aguarde", false);

    const { companyID } = this.props;

    db.collection("companies")
      .doc(companyID)
      .collection("results")
      .where("place", "==", id)
      .get()
      .then((snap) => {
        if (snap.empty) {
          this.hideAlert();
          this.waitAlert("Removendo, aguarde", false);
          db.collection("companies")
            .doc(companyID)
            .collection("places")
            .doc(id)
            .delete()
            .then(() => {
              this.hideAlert();
              this.notify("Local removido", "success");
            })
            .catch((e) => {
              this.hideAlert();
              this.notify("Erro ao remover local", "error");
            });
        } else {
          this.hideAlert();
          this.notify(
            "Este local possui ligações com os dados da empresa e não pode ser removido.",
            "warning"
          );
        }
      });
  };

  placeModal = () => {
    const { targetPlace } = this.state;
    return (
      <Modal
        title={targetPlace ? "Atualizar local" : "Adicionar local"}
        isOpen={this.state.placeModal}
        content={
          <PlaceForm
            initialValues={targetPlace}
            onSubmit={(values) => {
              targetPlace
                ? this._updatePlace(targetPlace.id)(values)
                : this._setPlace(values);
            }}
            handleCancel={() =>
              this.setState({ placeModal: false, targetPlace: null })
            }
          />
        }
      />
    );
  };

  _renderPlacesTable = (data) => (
    <ReactTable
      columns={[
        { Header: "Nome", accessor: "name" },
        {
          Header: "Ações",
          accessor: "",
          Cell: ({ value }) => (
            <div style={{ textAlign: "center" }}>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`edit_${value.id}`}>Editar</Tooltip>}
              >
                <a
                  className="btn btn-simple btn-default btn-icon"
                  onClick={() =>
                    this.setState({ targetPlace: value, placeModal: true })
                  }
                >
                  <FontAwesomeIcon className="text-dark" icon={faPencilAlt} />
                </a>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`remove_${value.id}`}>Remover</Tooltip>}
              >
                <a
                  className="btn btn-simple btn-danger btn-icon"
                  onClick={() => this.removeAlert(value.id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </a>
              </OverlayTrigger>
            </div>
          ),
        },
      ]}
      data={orderBy(toArray(data), ["name", "asc"])}
      onFetchData={this._fetchPlaces}
      loading={this.state.fetchingPlaces}
      defaultPageSize={10}
      className="-striped -highlight"
      previousText="Anterior"
      nextText="Próximo"
      loadingText="Carregando"
      noDataText="Nenhum local encontrado"
      pageText="Página"
      ofText="de"
      rowsText="Registros"
    />
  );

  //Notifications
  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: null,
      message: <b>{message}</b>,
      level,
      position: "tr",
      autoDismiss: 4,
    });
  };

  //SweetAlerts
  hideAlert = () => this.setState({ alert: null });

  removeAlert = (id) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block" }}
          title="Tem certeza?"
          onConfirm={() => this._remove(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="default"
          cancelBtnBsStyle="warning"
          confirmBtnText="Continuar"
          cancelBtnText="Cancelar"
          showCancel
        />
      ),
    });
  };

  waitAlert = (title, showSpinner) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block" }}
          title={title}
          onConfirm={() => null}
          showConfirm={false}
        >
          {showSpinner ? <SweetSpinner /> : null}
        </SweetAlert>
      ),
    });
  };
}

export default connect(null, { resetForm })(Places);



// WEBPACK FOOTER //
// ./src/views/Companies/Tabs/Places.jsx